var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-input-select',{attrs:{"label":this.$t('common.currency'),"options":_vm.currencyOptions,"help-danger":_vm.helpDanger,"value":_vm.currencies[0],"disabled":_vm.disabled,"fullwidth":_vm.fullwidth},on:{"input":_vm.handleCurrencySelect}})}
var staticRenderFns = []

export { render, staticRenderFns }